import { css } from "@emotion/react";
import { Theme } from "styles/theme";

export const getLegacyFontStyles = (theme: Theme) => {
  return {
    primary: css`
      font-family: ${theme.fontFamilies.Secondary};
      letter-spacing: 0px;
    `,
    secondary: css`
      font-family: "agenda-one";
      letter-spacing: 0px;
    `,
  };
};
